export function normalizeGenieSpaceNames(
  genieSpaceNames?: string[] | null,
  legacyGenieSpaceName?: string | null
): string[] | undefined {
  if (genieSpaceNames && genieSpaceNames.length > 0) {
    return genieSpaceNames;
  }

  if (legacyGenieSpaceName) {
    return [legacyGenieSpaceName];
  }

  return undefined;
}

export function getPrimaryGenieSpaceName(
  genieSpaceNames?: string[] | null,
  legacyGenieSpaceName?: string | null
): string | undefined {
  const normalizedGenieSpaceNames = normalizeGenieSpaceNames(genieSpaceNames, legacyGenieSpaceName);
  if (!normalizedGenieSpaceNames || normalizedGenieSpaceNames.length !== 1) {
    return undefined;
  }

  return normalizedGenieSpaceNames[0];
}
